const listService = [
  {
    alt: 'AIDC-Treatment Provided',
    image: 'images/services.jpg',
  },
];
const heroServices = 'AIDC-Treatment Provided';

export { heroServices, listService };
